import { createSlice } from "@reduxjs/toolkit";

export const userSettings = createSlice({
    name: 'settings',
    initialState: {
        country: "Kenya",
        language: "English",
        currency: {
            short: "Ksh",
            long: "Kenyan Shilling"
        }
    },
    reducers: {
        changeCountry: (state, action) => {
            state.country = action.payload
        },
        changeLanguage: (state, action) => {
            state.language = action.payload
        },
        changeCurrency: (state, action) => {
            state.currency = action.payload
        },
    }
})

export const {
    changeCountry,
    changeLanguage,
    changeCurrency,
} = userSettings.actions;

export default userSettings.reducer;